/**
 * Caja de imagen de un producto.
 *
 * Las fotos del catálogo llegan de tres proveedores distintos: unas vienen
 * recortadas al borde de la caja y otras traen su propio fondo blanco con
 * mucho aire alrededor. Sobre el tema oscuro eso hacía que dos juegos de la
 * misma fila parecieran de tamaños distintos, aunque ocuparan el mismo hueco.
 *
 * Encuadrarlas todas en una caja blanca de proporción fija las iguala: el
 * fondo propio de la foto se funde con el de la caja y lo único que cambia de
 * una tarjeta a otra es el producto. Por eso el fondo es blanco y no un gris
 * del tema — tiene que coincidir con el fondo que ya traen las fotos.
 *
 * Es el único sitio donde se decide cómo se enmarca una foto de producto; el
 * tamaño lo pone quien la usa vía `className` (`aspect-square`, `h-10 w-10`…).
 */
export default function ProductImage({
  src,
  alt,
  className = '',
  imgClassName = '',
  agotado = false,
  loading = 'lazy',
  onError,
}) {
  return (
    <div
      className={`bg-white overflow-hidden flex items-center justify-center ${className}`}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          loading={loading}
          onError={onError}
          className={`max-h-full max-w-full object-contain${agotado ? ' grayscale' : ''}${
            imgClassName ? ` ${imgClassName}` : ''
          }`}
        />
      ) : (
        <span className="text-xs text-gray-400 px-2 text-center">Sin imagen</span>
      )}
    </div>
  );
}
